import React, { useEffect, useState } from 'react';
import axios from '../axios';
import EntityForm from './EntityForm';

const LAYERS = [
    ['liner_outer', 'Liner Outer', 'LinerOuter'],
    ['liner_inner', 'Liner Inner', 'LinerInner'],
    ['bflute1', 'B Flute 1', 'BFlute1'],
    ['bflute2', 'B Plain', 'BFlute2'],
    ['cflute', 'C Flute', 'CFlute'],
    ['pmedium1', 'P. Medium 1', 'PMedium1'],
    ['pmedium2', 'P. Medium 2', 'PMedium2'],
];

function ManageGradeForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    const [gsmOptions, setGsmOptions] = useState([]);

    useEffect(() => {
        axios.get(`${window.backendUrl}/get_all_gsm`)
            .then((response) => setGsmOptions(response.data.data.map((gsm) => gsm['Name'] + ' ' + gsm['GSMValue'])))
            .catch((error) => console.error('Error fetching GSM list:', error));
    }, []);

    const layerOptions = [{ value: '', label: '' }, ...gsmOptions.map((gsm) => ({ value: gsm, label: gsm + ' GSM' }))];

    return (
        <EntityForm
            noun="Grade"
            heading="Add New Grade"
            idKey="GradeID"
            insertUrl="insert_manage_grade"
            updateUrl="update_manage_grade"
            deleteUrl="delete_manage_grade"
            saveLabel="Add"
            fields={[
                { name: 'name', label: 'Grade Name', entryKey: 'Name', required: true },
                ...LAYERS.map(([name, label, entryKey]) => ({ name, label, entryKey, type: 'select', options: layerOptions })),
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageGradeForm;
